import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

export const useLabChangeReasonsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [labChangeReasons, setLabChangeReasons] = useState<string[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(LAB_REPORT?.LAB_REPORT_LAB_CHANGE_REASONS?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          const reasons = res?.data?.status === true && Array.isArray(res?.data?.data) ? res.data.data : [];
          setLabChangeReasons(reasons);
        })
        .catch((e: AxiosError) => {
          setLabChangeReasons([]);
          e.config && sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      setLabChangeReasons([]);
      toast.error("Server Error: " + e.message);
    }
  }, [configuration, sendCurl, captureError]);

  return { execute, labChangeReasons };
};
